// Small localStorage-backed "recently viewed products" helper.
// Stores a rolling list of up to 8 product snapshots.
const KEY = "ji_recently_viewed_v1";
const MAX = 8;

const readAll = () => {
  try {
    const raw = typeof window !== "undefined" && window.localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

const writeAll = (arr) => {
  try { window.localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch { /* ignore */ }
};

/** Track a product view. Dedupes by id and moves the item to the front. */
export function trackProductView(product) {
  if (!product || !product.id) return;
  const snap = {
    id: product.id,
    name: product.name,
    image_url: product.image_url,
    price: product.list_price ?? product.price ?? null,
    brand: product.brand ?? null,
    category: product.category ?? null,
    part_number: product.part_number ?? null,
    supplier: product.supplier ?? null,
    affiliate_url: product.affiliate_url ?? null,
    viewed_at: Date.now(),
  };
  const prev = readAll().filter((p) => p.id !== product.id);
  writeAll([snap, ...prev]);
}

export function getRecentlyViewed(limit = 4) {
  return readAll().slice(0, limit);
}

export function clearRecentlyViewed() {
  try { window.localStorage.removeItem(KEY); } catch { /* ignore */ }
}
